import { defineStore } from 'pinia'

import type { LandingState } from './interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { actions } from './actions'
import { getters } from './getters'

export const useLandingStore = defineStore('landing', {
  state: (): LandingState => ({
    loading: false,
    availableSlots: [],
    allSlots: [],
    isExtendedSlots: false,
    longWindowAuto: false,
    selectedDate: null,
    selectedTime: null,
    kidId: null,
    disciplineCode: Discipline.Math,
    formValid: false,
    dateMode: 'normal',
    timeMode: 'normal',
    modalBookDemoSuccess: false,
    bookedDiscipline: null,
  }),
  actions,
  getters,
})
